import { isEqual } from 'lodash';

/**
 * Compares two values from two Objects
 * If the values are equal, this function returns undefined
 * otherwise it returns the value of the mutatedObject[key]
 * @param {T} initialObject - The initial immutable Object
 * @param {U} mutatedObject - This is the mutated Object
 * @param {K extends keyof T} keyOne - Key of the initialObject Object, that should be compared with
 *
 */
export const getChangedOrUndefined = <
  T,
  U,
  K extends keyof T,
  O extends keyof U,
>(
  initialObject: T,
  mutatedObject: U,
  keyOne: K | O,
): U[O] | undefined => {
  const secondKey = keyOne as O;
  if (!initialObject || !mutatedObject) {
    return;
  }

  return isEqual(initialObject[keyOne as K], mutatedObject[secondKey])
    ? undefined
    : mutatedObject[secondKey];
};
